import { paths } from '@/constants'
import { RegionContextProvider } from '@/contexts/RegionContext'
import { Seo } from '@/layout/Seo'
import { DefaultLayout, NextPageWithLayout } from '@/layouts'
import { getServerSidePropsErrorHandler } from '@/utils/nextUtils/nextErrorHandlers'
import { getBasePath } from '@/utils/sitemap/base'
import { useTranslate } from '@/utils/translate/translate-client'
import { loadTranslations } from '@/utils/translate/translate-server'
import { GuildVotingView } from '@/views/GuildVotingView'

interface GuildVotingPageProps {
  locale: string
}

const GuildVotingPage: NextPageWithLayout<GuildVotingPageProps> = ({ locale }) => {
  const { t } = useTranslate('guild-voting')
  const basePath = `${getBasePath(locale)}`
  const url = `${basePath}${paths.guild.voting}`
  const title = t('angelStudiosGuildVotingTitle', 'Angel Guild Voting | Angel Studios')
  const description = t(
    'angelStudiosGuildVotingDescription',
    'As an Angel Guild member, you can watch a torch, cast your vote, leave feedback for the filmmaker, and view voting results and track future progress.  Download the app to start voting.',
  )
  return (
    <>
      <Seo
        canonical={url}
        description={description}
        openGraph={{ title, description, url }}
        path={paths.guild.voting}
        title={title}
      />
      <RegionContextProvider>
        <GuildVotingView />
      </RegionContextProvider>
    </>
  )
}

GuildVotingPage.getLayout = (page) => {
  return <DefaultLayout>{page}</DefaultLayout>
}

export const getServerSideProps = getServerSidePropsErrorHandler(async ({ locale }) => {
  return {
    props: {
      locale,
      ...(await loadTranslations(locale, ['common', 'guild-voting', 'app-promo', 'watch'])),
    },
  }
})

export default GuildVotingPage
